import { get } from './base';
var URL = '/service';
export var GetPrivateSpaceAPI = function GetPrivateSpaceAPI() {
  return get("".concat(URL, "/private-space/"));
};
export var GetPrivateSpaceAPIById = function GetPrivateSpaceAPIById(id) {
  return get("".concat(URL, "/private-space/").concat(id, "/"));
};
export var GetMembershipServiceAPI = function GetMembershipServiceAPI() {
  return get("".concat(URL, "/membership-service/"));
};